/**
 * @lodex-pro/web-portal/components/portal-error-text — a failed portal write, in words.
 *
 * OPP PR 7 — the tank-setup and routes pages say what went wrong ("Another active route
 * already has that name.") rather than "Something went wrong". The words are the API error
 * catalog's own userMessage for the code the API returned, so the portal and the API never
 * word the same refusal two ways. The catalog subpath has no imports (unlike the shared
 * barrel, which pulls drizzle into a web bundle).
 */

import { ApiError } from '@lodex-pro/web-shared';
import { ERROR_CATALOG } from '@lodex-pro/shared/errors/catalog';

function catalogMessage(code: string): string | null {
  if (!Object.prototype.hasOwnProperty.call(ERROR_CATALOG, code)) return null;
  const entry = (ERROR_CATALOG as Record<string, { userMessage: string } | undefined>)[code];
  return entry?.userMessage ?? null;
}

/** The catalog's words for the error's code, or `fallback` when there is no code. */
export function portalErrorText(error: unknown, fallback: string): string {
  if (error instanceof ApiError && error.code !== null) {
    return catalogMessage(error.code) ?? fallback;
  }
  return fallback;
}
